import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import {getDistance} from 'ol/sphere';
import * as olProj from 'ol/proj';

const superagent = superagentPromise(_superagent, global.Promise);
const responseBody = res => res.body;

const optimalTrajectoryRequests = {
  //get data from redux
  get: (
          url,
          captcha,
          points, 
          length,
          wheelDistance, 
          radiusMiddle,
          positionOfRotationAxis,
          positionOfGnsReceiver,
          startLon,
          startLat,
          startVectX,
          startVectY,
          endLon,
          endLat,
          endVectX,
          endVectY,
          rowsDistance, 
          rowsAngle,
          aroundPerimeter,
    ) =>
    superagent.get(`${url}`)
    .query({captchaText:captcha})    
    .query({ points:points})
    .query({ length: length })
    .query({ wheelDistance: wheelDistance })
    .query({ radiusMiddle: radiusMiddle })
    .query({ positionOfRotationAxis: positionOfRotationAxis })
    .query({ positionOfGnsReceiver: positionOfGnsReceiver })
    .query({ startLon: startLon })    
    .query({ startLat: startLat })
    .query({ startVectX: startVectX })
    .query({ startVectY: startVectY })
    .query({ endLon: endLon })
    .query({ endLat: endLat })
    .query({ endVectX: endVectX })
    .query({ endVectY: endVectY })
    .query({ lineDistance: rowsDistance })
    .query({ lineAngle: rowsAngle })
    .query({ aroundPerimeter: aroundPerimeter })
    .withCredentials()
        
    .then(responseBody),
};

const OptimalTrajectory = {
  getTrajectoryPoints(rover, field) {
     let startTransformed = distanceFromRefPoint1(field.start, field.start);
     let endTransformed = distanceFromRefPoint1(field.end, field.start);
     let startVectorTransformed = distanceFromRefPoint1({Lon: (field.start.Lon + field.start.VectorX), Lat: (field.start.Lat + field.start.VectorY)}, field.start);
     let endVectorTransformed = distanceFromRefPoint1({Lon: field.end.Lon + field.end.VectorX, Lat:  field.end.Lat + field.end.VectorY}, field.end);

     return optimalTrajectoryRequests.get(
      '/api/TrajectoryPlanning/Points',
      field.captcha,
      JSON.stringify(pointsArrayToDistancesFromRefPoint(field.areaPolygon[0].coordinates[0], field.start)),
      rover.length, 
      rover.wheelDistance, 
      rover.turningRadius,
      rover.positionOfRotationAxis,
      rover.positionOfGnsReceiver,
      startTransformed.lonMeters,
      startTransformed.latMeters,
      startVectorTransformed.lonMeters,
      startVectorTransformed.latMeters,
      endTransformed.lonMeters,
      endTransformed.latMeters,
      endVectorTransformed.lonMeters,
      endVectorTransformed.latMeters,
      field.rowsDistance, 
      field.rowsAngle,
      field.aroundPerimeter
    )
  }
};

const pointsRequests = {
  //get data from redux
  get: (
          url,
          captcha,
          points, 
          length,
          wheelDistance, 
          radiusMiddle,
          positionOfRotationAxis,
          positionOfGnsReceiver,
    ) =>
    superagent.get(`${url}`)
    .query({captchaText:captcha})    
    .query({points:points})
    .query({ length: length })
    .query({ width: wheelDistance })//todo width
    .query({ radiusMiddle: radiusMiddle })
    .query({ positionOfRotationAxis: positionOfRotationAxis })
    .query({ positionOfGnsReceiver: positionOfGnsReceiver })
    .withCredentials()
    .then(responseBody),
};

const Points = {
  getTrajectoryPoints: (trajectoryPoints,rover) => pointsRequests.get(
      '/api/OptimalTrajectory/Points',
      trajectoryPoints.captcha,
      JSON.stringify(pointsToDistanceFromRefPointArray([...[trajectoryPoints.start],...trajectoryPoints.points,...[trajectoryPoints.end]]), trajectoryPoints.start),
      rover.length, 
      rover.wheelDistance, 
      rover.turningRadius,
      rover.positionOfRotationAxis,
      rover.positionOfGnsReceiver
    )
};

const obstaclesRequests = {
  //get data from redux
  get: (
          url,
          captcha,
          points, 
          obstacles, 
          length,
          wheelDistance, 
          radiusMiddle,
          positionOfRotationAxis,
          positionOfGnsReceiver,
          startLon,
          startLat,
          startVectX,
          startVectY,
          endLon,
          endLat,
          endVectX,
          endVectY,
          precision
    ) =>
    superagent.get(`${url}`)
    .query({captchaText:captcha})    
    .query({points:points})
    .query({ obstacles:obstacles })
    .query({ length: length })
    .query({ wheelDistance: wheelDistance })
    .query({ radiusMiddle: radiusMiddle })
    .query({ positionOfRotationAxis: positionOfRotationAxis })
    .query({ positionOfGnsReceiver: positionOfGnsReceiver })
    .query({ startLon: startLon })    
    .query({ startLat: startLat })
    .query({ startVectX: startVectX })
    .query({ startVectY: startVectY })
    .query({ endLon: endLon })
    .query({ endLat: endLat })
    .query({ endVectX: endVectX })
    .query({ endVectY: endVectY })   
    .query({ precision: precision })
    .withCredentials()
    .then(responseBody),
};

const Obstacles = {
  getTrajectoryPoints(rover, obstacles) { 

    let startTransformed = distanceFromRefPoint1(obstacles.start, obstacles.start);
    let endTransformed = distanceFromRefPoint1(obstacles.end, obstacles.start);
    let startVectorTransformed = distanceFromRefPoint1({Lon: (obstacles.start.Lon + obstacles.start.VectorX), Lat: (obstacles.start.Lat + obstacles.start.VectorY)}, obstacles.start);
    let endVectorTransformed = distanceFromRefPoint1({Lon: obstacles.end.Lon + obstacles.end.VectorX, Lat:  obstacles.end.Lat + obstacles.end.VectorY}, obstacles.end);
        
    return obstaclesRequests.get(
      '/api/AvoidingObstacles/Points',
      obstacles.captcha,
      JSON.stringify(pointsArrayToDistancesFromRefPoint(obstacles.areaPolygon[0].coordinates[0], obstacles.start)),
      JSON.stringify(obstaclesToDistanceFromRefPointArray(obstacles, obstacles.start)),
      rover.length, 
      rover.wheelDistance, 
      rover.turningRadius,
      rover.positionOfRotationAxis,
      rover.positionOfGnsReceiver,
      startTransformed.lonMeters,
      startTransformed.latMeters,
      startVectorTransformed.lonMeters,
      startVectorTransformed.latMeters,
      endTransformed.lonMeters,
      endTransformed.latMeters,
      endVectorTransformed.lonMeters,
      endVectorTransformed.latMeters,
      obstacles.precision 
    )
  }
};

function obstaclesToDistanceFromRefPointArray(obstacles, refPoint) {
  let pointsArray = [];
  for (let obstacle of obstacles.obstacles) {
    let transformedCoords = [];
    for (let cooridinate of obstacle.coordinates[0]) {
      let pointTransformed = distanceFromRefPoint1({Lon: cooridinate[0], Lat: cooridinate[1]}, refPoint);
      transformedCoords.push([pointTransformed.lonMeters, pointTransformed.latMeters]);
    }
    pointsArray.push(transformedCoords);
  }
  return pointsArray;
}

function pointsToDistanceFromRefPointArray(points) {
  let pointsArray = [];
  if (!points || points.length === 0)
    return [];

  let startPoint = points[0];
  for (let point of points) {
    let pointTransformed = distanceFromRefPoint1(point, startPoint);
    let vectorTransformed = distanceFromRefPoint1({Lon: point.Lon + point.VectorX, Lat: point.Lat + point.VectorY}, point)

    pointsArray.push([
      pointTransformed.lonMeters,
      pointTransformed.latMeters,
      vectorTransformed.lonMeters,
      vectorTransformed.latMeters,
    ]);
  }
  return pointsArray;
}

function distanceFromRefPoint1(value, refPoint) {
  if (!value || !refPoint)
    return null

  let middleLon = ((value.Lon - refPoint.Lon)/2) + refPoint.Lon;
  let refPontTransformedLat = olProj.transform([middleLon, refPoint.Lat], 'EPSG:3857', 'EPSG:4326');
  let pointTransformedLat = olProj.transform([middleLon, value.Lat], 'EPSG:3857', 'EPSG:4326');

  let middleLat = ((value.Lat - refPoint.Lat)/2) + refPoint.Lat;
  let refPontTransformedLon = olProj.transform([refPoint.Lon, middleLat], 'EPSG:3857', 'EPSG:4326');
  let pointTransformedLon = olProj.transform([value.Lon, middleLat], 'EPSG:3857', 'EPSG:4326');

  let lonMeters =  getDistance(pointTransformedLon, refPontTransformedLon) * (pointTransformedLon[0] >= refPontTransformedLon[0] ? 1 : -1);
  let latMeters =  getDistance(pointTransformedLat, refPontTransformedLat) * (pointTransformedLat[1] >= refPontTransformedLat[1] ? 1 : -1);
  return {lonMeters: lonMeters, latMeters:latMeters}
};

function pointsArrayToDistancesFromRefPoint(array, refPoint) {
  let transformedArray = [];

  array.forEach(item => {
    let transformedPoint = distanceFromRefPoint1({Lon:item[0], Lat:item[1]}, refPoint);
    transformedArray.push([transformedPoint.lonMeters, transformedPoint.latMeters]);
  });

  return transformedArray;
}

const isReadyRequests = {
  get: (url
    ) =>
    superagent.get(`${url}`)
    .timeout({
      response: 500, 
      deadline: 500,
    })
    .then(responseBody),
};

const IsReady = {
  testRequests: () => isReadyRequests.get(
    '/api/Home/IsReady', 
    )
};

export {
  OptimalTrajectory,
  Points,
  Obstacles, 
  IsReady
};